const _globalMethod = {
  install: function (Vue) {
      Vue.prototype.addClass = function (obj, newClass) {
        if (!this.hasClass(obj, newClass)) {//如果obj没有这个类，才添加
          var obj_class = obj.className;//获取 class 内容.
          var blank = (obj_class != '') ? ' ' : '';//判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
          var added = obj_class + blank + newClass;//组合原来的 class 和需要添加的 class.
          obj.className = added;//替换原来的 class.
        }
      },
      Vue.prototype.removeClass = function (obj, newClass) {
        var obj_class = ' ' + obj.className + ' ';//获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
        obj_class = obj_class.replace(/(\s+)/gi, ' ');//将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
        var removed = obj_class.replace(' ' + newClass + ' ', ' ');//在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
        removed = removed.replace(/(^\s+)|(\s+$)/g, '');//去掉首尾空格. ex) 'bcd ' -> 'bcd'
        obj.className = removed;//替换原来的 class.
      },
      Vue.prototype.hasClass = function (elem, cls) {
        cls = cls || '';
        if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
        return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
      },
      Vue.prototype.duplicate = function (_array) {//数组去重
        //console.log("去重");
        var r = [];
        for (var i = 0, l = _array.length; i < l; i++) {
          for (var j = i + 1; j < l; j++)
            if (_array[i] === _array[j]) j = ++i;
          r.push(_array[i]);
        }
        return r;
      },
      Vue.prototype.dataRepeat = function (_array, data) {//检测数组中的最后一个元素之前重复出现过没
        var onOff = false;
        for (var i = 0; i < _array.length - 1; i++) {
          if (data == _array[i]) {
            onOff = true;
          }
        }
        return onOff;
      },
      Vue.prototype.sortToFirst = function (_array, cus_attr) {//如果数组元素中的cusindex等于cus_attr,就把这个元素放置到最前
        var obj_temp;
        for (var i = 0; i < _array.length; i++) {
          if (_array[i].cusindex == cus_attr) {
            obj_temp = _array[i];
            _array.splice(i, 1);
          }
        }
        _array.unshift(obj_temp);
      },
      //自动触发iNow_cusindex的click事件
      Vue.prototype.iNow_cusindex = function (_array, data) {
        for (var i = 0; i < _array.length; i++) {
          if (_array[i] == data) {
            return _array[i + 1];
          }
        }
      },
      //清除所有导航的高亮
      Vue.prototype.clearHighLight = function (ele) {
        for (var i = 0; i < ele.length; i++) {//清除所有的高亮
          this.removeClass(ele[i], "is-active");
        }
      },
      //给特定导航加上高亮
      Vue.prototype.fixedAddHighLight = function (ele, cusindex) {
        for (var i = 0; i < ele.length; i++) {
          if (ele[i].getAttribute("cusindex") == cusindex) {
            this.addClass(ele[i], "is-active");
            break;
          }
        }
      },
      //简单一行提示语
      Vue.prototype.simpleNotice = function (text) {
        var html = "";
        var simpleNotice = $('<div class="popup-alone popup-alone-line">' +
          '<div class="popup-a-n-bg"></div>' +
          '<div class="popup-a-n-content">' +
          '<div class="popup-del"></div>' +
          '<div class="alone-line-text">' + text + '</div>' +
          '<div class="popup-btn-sure">确定</div>' +
          '</div>' +
          '</div>');
        $("body").append(simpleNotice);
      },
      //tab标签右键
      Vue.prototype.contextMenus = function (jq_ele) {
        var contentMenuPre = $("body").find(".contextLists");
        contentMenuPre.remove();
        var contextMenus = $('<div class="contextLists contextLists-right">' +
          '<div class="context-close"></div>' +
          '<div class="contextListsSub close-current">关闭当前页面</div>' +
          '<div class="contextListsSub close-other">关闭其他页面</div>' +
          '<div class="contextListsSub close-all">关闭所有页面</div>' +
          '</div>');
        //获取导入jq元素的特定位置：右键菜单的左上角或者右上角位于该特定位置
        var ele_top = jq_ele.offset().top;
        var ele_left = jq_ele.offset().left;
        var ele_wid = jq_ele.width();
        var ele_height = jq_ele.height();
        var pos_menu_top = ele_top + ele_height * 3 / 4;//菜单最终的top位置
        var pos_menu_left = ele_left + ele_wid / 2;//菜单最终的left位置
        contextMenus.offset({top: pos_menu_top, left: pos_menu_left});
        $("body").append(contextMenus);
      },
      //右键菜单点击效果
      Vue.prototype.clickIndex = function (callBack, cusindex, parentindex, cusEvent) {
        //右键弹窗关闭
        $(".context-close").off("click").on("click", function () {
          $(this).parent().remove();
        });
        //定义返回值: 0->关闭当前页面  1->关闭其他页面  2->关闭所有页面
        var click_index;
        $(document).off("click", ".contextLists .close-current").on("click", ".contextLists .close-current", function () {
          click_index = 0;
          var contentMenuPre = $("body").find(".contextLists");
          contentMenuPre.remove();
          callBack && callBack(cusindex, click_index, parentindex, cusEvent);
        });
        $(document).off("click", ".contextLists .close-other").on("click", ".contextLists .close-other", function () {
          click_index = 1;
          var contentMenuPre = $("body").find(".contextLists");
          contentMenuPre.remove();
          callBack && callBack(cusindex, click_index, parentindex, cusEvent);
        });
        $(document).off("click", ".contextLists .close-all").on("click", ".contextLists .close-all", function () {
          click_index = 2;
          var contentMenuPre = $("body").find(".contextLists");
          contentMenuPre.remove();
          callBack && callBack(cusindex, click_index, parentindex, cusEvent);
        });
      },
      //删除数组中重复的数据

      //table项公共事件-------------------start
      //判断至少有一个checkbox选中
      Vue.prototype.orOneCheck = function (array) {
        var checkOnOff = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].checkbox) {
            checkOnOff = true;
          }
        }
        return checkOnOff;
      },
      //判断数组元素中被选中的个数
      Vue.prototype.getNumCheck = function (array) {
        var number = 0;
        for (var i = 0; i < array.length; i++) {
          if (array[i].checkbox) {
            number++;
          }
        }
        return number;
      },
      //清空数组中所有的选中状态
      Vue.prototype.emptyCheckbox = function (array) {
        for (var i = 0; i < array.length; i++) {
          array[i].checkbox = false;
        }
      },
      //获取选中checkbox对应table数据中对应的唯一id值:其中idName是唯一的那个数据，传入这个值，是因为后端给的数据，唯一的id名有可能不一样
      Vue.prototype.getCheckID = function (array, idName) {
        for (var i = 0; i < array.length; i++) {
          if (array[i].checkbox) {
            return array[i][idName];
          }
        }
      },
      //获取所有选中项的idName
      Vue.prototype.getAllCheckID = function (array, idName) {
        var array_temp = [];
        for (var i = 0; i < array.length; i++) {
          if (array[i].checkbox) {
            array_temp.push(array[i][idName]);
          }
        }
        return array_temp;
      },
      //通用版本管理->审核：idName:父组件中唯一的id值;ObtainIdname:父组件根据选择框之后传入子组件的唯一id值
      // state:大数据中状态对应的字段;examine:审核通过或者不通过的值;其中idName是唯一的那个数据，state是状态值，是因为后端给的数据，唯一的id名有可能不一样
      Vue.prototype.modifyCheckID = function (array, idName, ObtainIdname, state, examine_state) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][idName] == ObtainIdname) {
            array[i][state] = examine_state;
          }
        }
      },
      Vue.prototype.getiNowCusindex = function () {
        //获取当前点击导航的cusindex,通过该值，需要遍历基础数据表找到对应cusindex的数据

        /*刷新调整--start*/
        var nav_iNow;
        var get_session_nav_iNow = sessionStorage.getItem("session_active_iNow");
        if (get_session_nav_iNow) {
          this.$store.commit("setiNow", get_session_nav_iNow);//根据sessionStorage同步active_iNow
        }
        nav_iNow = this.$store.getters.get_iNow;
        /*刷新调整----end*/

        return nav_iNow;
      },
      Vue.prototype.getiNowData = function () {
        /*刷新调整--start*/
        var nav_router;
        var get_session_nav_router = JSON.parse(sessionStorage.getItem("session_nav_router"));//获取所有的数据
        if (get_session_nav_router) {
          //this.$store.commit("setNavList",get_session_nav_router);//根据sessionStorage同步nav_router
          nav_router = get_session_nav_router;
        } else {
          nav_router = this.$store.getters.get_nav_list;//获取所有的数据
        }
        /*刷新调整----end*/
        return nav_router;
      },
      //清空所有左侧导航高亮
      Vue.prototype.emptyHighlightNav = function () {
        var nav_list_total = document.getElementsByClassName("cus-nav");
        for (var i = 0; i < nav_list_total.length; i++) {
          this.removeClass(nav_list_total[i], "is-active");
        }
      },
      //重置sessionStorage中的数据
      Vue.prototype.emptySessionStorage = function () {
        /*刷新调整--start*/
        var active_nav_temp = [];
        sessionStorage.setItem("session_active_nav", JSON.stringify(active_nav_temp));//根据vueX中的active_nav初始值,储存到sessionStorage

        var active_iNow_temp = "";
        sessionStorage.setItem("session_active_iNow", active_iNow_temp);//根据vueX中的active_iNow初始值,储存到sessionStorage

        var carData_temp = [];
        sessionStorage.setItem("session_carData", JSON.stringify(carData_temp));//根据vueX中的carData初始值,储存到sessionStorage

        var accountData_temp = [];
        sessionStorage.setItem("session_accountData", JSON.stringify(accountData_temp));//根据vueX中的accountData初始值,储存到sessionStorage

        var productWarranty_temp = [];
        sessionStorage.setItem("session_productWarranty", JSON.stringify(productWarranty_temp));//根据vueX中的productWarranty初始值,储存到sessionStorage

        var productAuthorize_temp = [];
        sessionStorage.setItem("session_productAuthorize", JSON.stringify(productAuthorize_temp));//根据vueX中的productAuthorize初始值,储存到sessionStorage

        var historyAuthorize_temp = [];
        sessionStorage.setItem("session_historyAuthorize", JSON.stringify(historyAuthorize_temp));//根据vueX中的historyAuthorize初始值,储存到sessionStorage

        var machineNewOnOff_temp = true;
        sessionStorage.setItem("session_machineNewOnOff", machineNewOnOff_temp);//根据vueX中的machineNewOnOff初始值,储存到sessionStorage

        var tabVisible_temp = this.$store.getters.get_tabVisible_original;//获取Vuex中的跨模块数据
        sessionStorage.setItem("session_tabVisible", JSON.stringify(tabVisible_temp));//根据vueX中的tabVisible初始值,储存到sessionStorage

        sessionStorage.setItem( "session_Configid","" );
        sessionStorage.setItem( "session_Route","" );
        /*刷新调整----end*/
      },
      //点击关闭tab标签后，触发点击上一个或者下一个tab
      Vue.prototype.triggerClick = function (jq_ele, cusindex) {
        for (var i = 0; i < jq_ele.length; i++) {//tab切换页点击
          if (jq_ele[i].getAttribute("cusindex") == cusindex) {
            jq_ele[i].click();
            break;
          }
        }
      },
      //车型数据授权、用户账号列表等查看子项的路由参数
      Vue.prototype.pubConfigID = function( paramConfigID ){
        var targetConfitID;
        var configIDTemp = sessionStorage.getItem( "session_Configid" );
        var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff;//获取Vuex中的跨模块数据
        //如果是正常切换，就用vuex中的数据
        if( pageRefreshOnOff ){
          targetConfitID = paramConfigID;
        //如果是刷新，就用sessionStorage中的数据
        }else{
          if( configIDTemp ){
            targetConfitID = configIDTemp;
          }
        }
        return targetConfitID;
      },
      //车型数据授权、用户账号列表等查看子项的路由参数
      Vue.prototype.pubConfigAPI = function( paramConfigAPI ){
        var targetConfitApi;
        var configIDTemp = sessionStorage.getItem( "session_Route" );
        var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff;//获取Vuex中的跨模块数据
        //如果是正常切换，就用vuex中的数据
        if( pageRefreshOnOff ){
          targetConfitApi = paramConfigAPI;
        //如果是刷新，就用sessionStorage中的数据
        }else{
          if( configIDTemp ){
            targetConfitApi = configIDTemp;
          }
        }
        return targetConfitApi;
      },
      //车型数据授权、用户账号列表等查看子项的路由参数
      Vue.prototype.pubConfigName = function( paramConfigName ){
        var targetConfitName;
        var configNameTemp = sessionStorage.getItem( "session_transmitName" );
        var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff;//获取Vuex中的跨模块数据
        //如果是正常切换，就用vuex中的数据
        if( pageRefreshOnOff ){
          targetConfitName = paramConfigName;
          //如果是刷新，就用sessionStorage中的数据
        }else{
          if( configNameTemp ){
            targetConfitName = configNameTemp;
          }
        }
        return targetConfitName;
      }
  }
}

export default {_globalMethod}



// WEBPACK FOOTER //
// ./src/assets/javascripts/vue-public.js